import { useMemo } from "react";

import type { AnyObject } from "@similarweb/pro-logic-components";

export const usePaddedPreviewData = <T = AnyObject>(data: T[] | undefined, pageSize: number, isPreview: boolean) => {
    return useMemo(() => {
        if (!data) {
            return data;
        }

        if (isPreview && data.length < pageSize) {
            const emptyRowsNeeded = pageSize - data.length;
            const emptyRows = Array.from({ length: emptyRowsNeeded }, () => ({}) as T);

            return [...data, ...emptyRows];
        }

        return data;
    }, [data, pageSize, isPreview]);
};
